interface Props {
  text: string;
  isSelected?: boolean;
  onSelect?: () => void;
  selectable?: boolean;
  className?: string;
}

export default function TagItem(props: Props) {
  const { text, onSelect, selectable, className, isSelected } = props;

  const getSelectionBasedStyleClasses = () => {
    if (isSelected) {
      return "bg-promGray2 text-white";
    }
    return "text-promGray2";
  };

  const handleClick = () => {
    onSelect?.();
  };

  return (
    <div
      className={`border border-promGray2 rounded-2.5xl shadow-customMin w-auto inline-block px-3 ${
        selectable ? "cursor-pointer" : ""
      } ${getSelectionBasedStyleClasses()} ${className ?? ""}`}
      onClick={handleClick}
    >
      {text}
    </div>
  );
}
